import { IAuditNode, IFormularLink, IModel, ITemplateNode } from '@alberta/konexi-shared';
import moment from 'moment';
import { v4 } from 'uuid';

import { AuditNodeResponseDto } from './audit-node-response-dto.model';
import { SelectableDto } from './selectable-dto.model';

export class AuditNodeDto implements IAuditNode, IModel {
  isSystemNode;
  id: string;
  _id: string;
  archived: boolean;
  timestamp: Date;

  responses: AuditNodeResponseDto[] = [];
  color;
  description;
  mandatory;
  nodeType_Id;
  options;
  parentId;
  systemNode;
  failedResponse;
  selectables: SelectableDto[] = [];
  title;
  unit;
  children: AuditNodeDto[] = [];
  conditionTriggerId;
  conditionId;
  templateNodeId;
  globalType: string;
  characterLimit;
  _name: string;
  hidden: boolean;
  linked: IFormularLink;
  allowDrawPicture: boolean;

  public static createByTemplate(
    templateNode: ITemplateNode,
    parentId: string,
    prefillData: any[],
    account: any
  ): IAuditNode {
    const auditNode = new AuditNodeDto();
    auditNode.id = v4();
    auditNode._id = auditNode.id;
    auditNode.archived = false;
    auditNode.parentId = parentId;

    if (templateNode.isSystemNode) {
      switch (templateNode.systemNode) {
        case 4:
          auditNode.responses = [{ value: moment.utc().toISOString() }];
          break;
        case 5:
          auditNode.responses = [
            {
              value: account ? `${account.firstName} ${account.lastName}` : '',
            },
          ];
          break;
      }
    }
    auditNode.color = templateNode.color;
    auditNode.description = templateNode.description;
    auditNode.mandatory = templateNode.mandatory;
    auditNode.nodeType_Id = templateNode.nodeType_Id;
    auditNode.options = templateNode.options;
    auditNode.isSystemNode = templateNode.isSystemNode;
    auditNode.systemNode = templateNode.systemNode;
    auditNode.failedResponse = templateNode.failedResponse;
    auditNode.templateNodeId = templateNode._id;
    auditNode.hidden = templateNode.hidden;
    if (templateNode.selectables) {
      templateNode.selectables.forEach(selectable => {
        auditNode.selectables.push({
          color: selectable.color,
          label: selectable.label,
          selected: selectable.selected,
          value: selectable.value,
        });
      });
    }
    auditNode.title = templateNode.title;
    auditNode.unit = templateNode.unit;
    auditNode.globalType = templateNode.globalType;
    auditNode.characterLimit = templateNode.characterLimit;
    auditNode._name = templateNode._name;
    auditNode.allowDrawPicture = (templateNode as any).allowDrawPicture;
    auditNode.linked = templateNode.linked;
    const data = prefillData.find(f => f._id === templateNode._id || f._id === auditNode.nodeType_Id);
    if (data) {
      auditNode.responses = [{ value: data.value, integratedCares: data.integratedCares }];
    }

    return auditNode;
  }
}
